import React from "react"

export type ReactUseState<T> = {
  state: T
  setState: React.Dispatch<React.SetStateAction<T>>
}

export const IsSearchingContext = React.createContext<ReactUseState<boolean>>(
  {} as ReactUseState<boolean>
)

export const IsRestoreSearchingContext = React.createContext<
  ReactUseState<boolean>
>({} as ReactUseState<boolean>)

export const GridInitializedContext = React.createContext<
  ReactUseState<boolean>
>({} as ReactUseState<boolean>)

export const searchDyFromContext = React.createContext<
  ReactUseState<string | null | undefined>
>({} as ReactUseState<string | null | undefined>)

export const searchDyToContext = React.createContext<
  ReactUseState<string | null | undefined>
>({} as ReactUseState<string | null | undefined>)

export const searchYosyaKaisyaCdContext = React.createContext<
  ReactUseState<string | undefined>
>({} as ReactUseState<string | undefined>)

export const searchYosyaKaisyaNmContext = React.createContext<
  ReactUseState<string | undefined>
>({} as ReactUseState<string | undefined>)

// TODO:API確定後、responseの型に変更
export const SearchResultContext = React.createContext<any[] | undefined>([])

/**
 * 運送業務発注書印刷のProvider
 */
export const UnsogyomuHatyusyoProvider: React.FC<{
  isSearching: ReactUseState<boolean>
  isRestoreSearching: ReactUseState<boolean>
  gridInitialized: ReactUseState<boolean>
  SearchResult: Array<Object> | undefined
}> = (props) => {
  return (
    <IsSearchingContext.Provider value={props.isSearching}>
      <SearchResultContext.Provider value={props.SearchResult}>
        <GridInitializedContext.Provider value={props.gridInitialized}>
          <IsRestoreSearchingContext.Provider value={props.isRestoreSearching}>
            {props.children}
          </IsRestoreSearchingContext.Provider>
        </GridInitializedContext.Provider>
      </SearchResultContext.Provider>
    </IsSearchingContext.Provider>
  )
}
